import { SharedStateProvider, TransitionsOfCareContent } from "@metriport/shared-internal";
import { useNavigate } from "react-router-dom";
import { ossBaseUrlEmbedPage } from "../../../api/api";
import { useAppContext } from "../../contexts/app/index";

export default function TcmPage() {
  const { state } = useAppContext();
  const navigate = useNavigate();

  if (!state.isLoaded) {
    return null;
  }

  function getPatientUrl(patientId: string) {
    return `/embed/app/patient/${patientId}`;
  }

  function handleNavigateToPatient(patientId: string) {
    navigate(getPatientUrl(patientId));
  }

  return (
    <SharedStateProvider
      authToken={state.authToken}
      baseUrl={ossBaseUrlEmbedPage}
      ehrDetails={undefined}
      featureFlags={state.featureFlags}
    >
      <TransitionsOfCareContent
        onNavigateToPatient={handleNavigateToPatient}
        getPatientUrl={getPatientUrl}
      />
    </SharedStateProvider>
  );
}
